var sound_control_default = {
  "root": "_1ZzsU",
  "sliderContainer": "Wbx6B"
};
export {
  sound_control_default as default
};
//# sourceMappingURL=sound-control-scss.js.map
